<priva-dialog
    [hasFooter]="false"
    [title]="title || scannedCode?.number?.toString() || ('GENERAL.TITLE.CONTAINER' | translate)"
    (close)="closeDialog()"
>
    <div class="content-wrapper">
        <button
            priva-button
            importance="secondary"
            status="danger"
            (click)="removeContainer()"
            iconClass="fas fa-trash-can"
            iconState="left"
            data-test="remove-scanned-container-btn"
        >
            {{ 'GENERAL.ACTION.REMOVE' | translate }}
        </button>
    </div>
</priva-dialog>
